export var combineUrl = function (baseUrl, queryParameters) {
    if (baseUrl === void 0) { baseUrl = ''; }
    var hasQuery = baseUrl.indexOf('?') > -1;
    var query = '';
    if (queryParameters) {
        query = Object.keys(queryParameters)
            .map(function (key) { return key + "=" + queryParameters[key]; })
            .join('&');
    }
    return query === '' ? baseUrl : "" + baseUrl + (hasQuery ? '&' : '?') + query;
};
